import { TransactionType } from "../api/transactions.api";

/**
 * Converts a transaction type to a human descriptor
 */
export const transactionTypeToHuman = (type: TransactionType): string => {
  switch (type) {
    default:
    case TransactionType.CHARGE:
      return "payment";
    case TransactionType.REFUND:
      return "refund";
  }
};